import { render, staticRenderFns } from "./TypeSelector.vue?vue&type=template&id=b2c4a91c"
import script from "./TypeSelector.vue?vue&type=script&lang=js"
export * from "./TypeSelector.vue?vue&type=script&lang=js"
import style0 from "./TypeSelector.vue?vue&type=style&index=0&id=b2c4a91c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports